import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/index'
// import './registerServiceWorker'
import AppToast from '@/utils/AppToast'
import AppModal from '@/components/shared/AppModal'
import * as AppDateFilter from '@/utils/AppDateFilter'
import * as AppDateTimeFilter from '@/utils/AppDateTimeFilter'

import Vuelidate from 'vuelidate'
import vClickOutside from 'v-click-outside'

import 'izitoast/dist/css/iziToast.css'
import 'leaflet/dist/leaflet.css'
import BootstrapVue from 'bootstrap-vue'
import Popper from 'popper.js'
import Clipboard from 'v-clipboard'

import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(customParseFormat)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(localizedFormat)
dayjs.extend(utc)
dayjs.extend(timezone)

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.config.productionTip = process.env.NODE_ENV !== 'production'

Vue.use(Vuelidate)
Vue.use(vClickOutside)
Vue.use(Clipboard)
Vue.use(BootstrapVue)
Vue.use(AppToast)
Vue.component(AppModal.name, AppModal)

Vue.filter(AppDateFilter)
Vue.filter(AppDateTimeFilter)

window.fpm = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
